<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre1">The little party stood and watched as the aeroplane moved swiftly along the ground, rose, and soared into the air. Higher and higher it rose, till the features of the two occupants were almost invisible.</p>
<p class="calibre1">"Now," said Brother Frank. "Now watch. Now he's going to loop the loop."</p>
<p class="calibre1">But the wheels of the aeroplane still pointed to the ground. It grew smaller and smaller. It was a mere speck.</p>
<p class="calibre1">"What the dickens?"</p>
<p class="calibre1">Far away to the West something showed up against the blue of the sky—something that might have been a bird, a toy kite, or an aeroplane traveling rapidly into the sunset.</p>
<p class="calibre1">Four pairs of eyes followed it in rapt silence.</p>
<p class="calibre1"><a class="calibre3" id="link2H_4_0002"></a></p>
<div class="c">
<br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section006_split_000.vue?a645c3ec